'use client'

import { useEffect, useRef } from 'react'

export function useCountdown({
  running,
  seconds,
  onTick,
  onEnd
}: {
  running: boolean
  seconds: number
  onTick: (s: number) => void
  onEnd: () => void
}) {
  const secsRef = useRef(seconds)

  useEffect(() => {
    secsRef.current = seconds
  }, [seconds])

  useEffect(() => {
    if (!running) return
    const id = setInterval(() => {
      const next = secsRef.current - 1
      secsRef.current = next
      onTick(next)
      if (next <= 0) {
        clearInterval(id)
        onEnd()
      }
    }, 1000)
    return () => clearInterval(id)
  }, [running, onTick, onEnd])
}
